<template>
  <div>
    <!-- <div class="register_head">
    </div> -->
    <div class="register_body">
      <div class="register_white">
        <div class="register_form">
            <div class="register_tit">注册体验账号</div>
            <div class="register_mid">
              <div>
                  <div>体验账号自申请之日起1个月内有效</div>
                  <!-- <div class="regform-td" style="display: flex;flex-direction: row;align-items: center;">
                      <span></span><input type="radio" id="choose1" name="contact" value="0" v-model.trim="iftmsplus"/><label for="choose1">私募/团队</label>
                      <input type="radio" id="choose2" name="contact" value="1"  v-model.trim="iftmsplus"/><label for="choose2">期货资管部门</label>
                  </div> -->
                  <div class="regform-td">
                      <span>*机构名称</span><input type="text" v-model.trim="jgmc" />
                  </div>
                  <div class="regform-td">
                      <span>*姓名</span><input type="text" v-model.trim="name" />
                  </div>
                  <div class="regform-td" >
                      <span>*手机号</span><input type="text" v-model.trim="phone" ref="yzmcode"/>
                  </div>
                  
                  <div class="regform-td">
                      <span>*验证码</span><input type="text" v-model.trim="yzm"  style="width:220px"/>
                      <div style="position:relative;display:inline-block;vertical-align: bottom;" >
                        <div class="getyzm" @click="setyzm(true)">{{txtyzm}}</div>
                        <div id="sc" v-if="showyzm1" ></div>
                      </div>
                  </div>
              </div>
              <div class="regform-btn" @click="submitzc">确认</div>
              <div style="text-align:center" class="regformlink">
                <span @click="show()" :class="{'activetyzh':ifshowzh}" style="position:relative">找回体验账号密码<span class="huang"  v-if="ifshowzh"></span></span>
                <span><a href="https://www.wenhua.com.cn/Home/SimulationTradeRegistor" target="_blank">注册模拟资金账号</a></span>
              </div>
              <div v-if="ifshowzh">
                <!-- <div class="regform-td" style="display: flex;flex-direction: row;align-items: center;">
                      <span></span><input type="radio" id="choose3" name="contact1" value="0" v-model.trim="iftmspluszh"/><label for="choose3">私募/团队</label>
                      <input type="radio" id="choose4" name="contact1" value="1"  v-model.trim="iftmspluszh"/><label for="choose4">期货资管部门</label>
                </div> -->
                <div class="regform-td">
                    <span>*手机号</span><input type="text" v-model.trim="zhphone" />
                </div>
                <div class="regform-td">
                    <span>*验证码</span><input type="text" v-model.trim="zhyzm"  style="width:220px"/>
                    <div style="position:relative;display:inline-block">
                        <div class="getyzm"  @click="setyzm(false)">{{txtyzm1}}</div>
                        <div id="sc" v-if="!showyzm1" ></div>
                    </div>
                </div>
                <div class="regform-btn" @click="submitzh">确认</div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <loading v-if="loading"></loading>
    <basealert v-if="basealert" v-model="basedata" @showalert="showalert" :alertplus="alertplus"></basealert>
    <box v-if="box" @showbox="showboxx" :message="message"></box>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import loading from '../components/loading.vue';
import basealert from '../components/basealert.vue';
import box from '../components/box.vue';
export default {
  components: { loading, basealert, box },
  data() {
    return{
      //表单需要
      // iftmsplus:0,
      // iftmspluszh:0,
      alertplus:'',
      jgmc:'',
      name:'',
      phone:'',
      yzm:'',
      zhyzm:'',
      zhphone:'',
      sessionid:'',
      sig:'',
      token:"",
      //
      ifshowzh:false,
      txtyzm:"获取验证码",
      txtyzm1:'获取验证码',
      canclick:true,
      // suc:false,
      showyzm1:false,
      loading:false,
      basealert:false,
      box:false,
      message:"",
      basedata:{
        // code: "0",
        //         data: {gydm: "8033", gypwd: "4444", whid: null, whpwd: null},
        //         msg: "找回密码成功！",
        //         status: true
                },
    }
  },
  methods:{
    show(){
      console.log(this.ifshowzh)
      this.ifshowzh=!this.ifshowzh
    },
    showboxx(showbox) {
      this.box = showbox;
    },
    showalert(x) {
      this.basealert = x;
    },
    submitzc(){
       var formMess = {
        name: this.name,
        phone: this.phone,
        code: this.yzm,
        tmsplus:0,
        email: " ",
        jgmc: this.jgmc,
      };
      this.loading=true
      axios.post("https://www.wenhua.com.cn/api/dataapi/GyxtAdd",qs.stringify(formMess),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          console.log(res)
          this.loading=false
          if (res.data.status) {
            if(String(res.data.code)=='20'){
              this.message = res.data.msg;
              this.box = true;
            }
            else{
              this.basealert=true
              this.alertplus=0
              this.basedata=res.data
            }
          } else {
            this.message = res.data.msg;
            this.box = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          this.loading=false
        });
    },
    submitzh() {
      //账号找回
      var formMess = {
        phone: this.zhphone,
        code: this.zhyzm,
        tmsplus:0,
      };
      this.loading=true
      axios.post("https://www.wenhua.com.cn/api/dataapi/GyxtFind",qs.stringify(formMess),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          this.loading=false
          if (res.data.status) {
            this.basealert=true
            this.alertplus=0
            this.basedata=res.data
          } else {
            this.message = res.data.msg;
            this.box = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          this.loading=false
        });
    },
    setyzm(bol){
      if(!this.canclick) return;
      this.showyzm1=bol
      this.setic()
    },
    setic(){
        let _this = this;
        this.$nextTick(()=>{
          if(document.documentElement.querySelector('#sc')){
          document.documentElement.querySelector("#sc").style.width = this.$refs.yzmcode.offsetWidth + 'px'
          window.initAliyunCaptcha({
            
              // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
              SceneId: "17lat2dd",// H5场景：1ppoxyts  Web场景：17lat2dd
              // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
              mode: "embed",
              // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
              element: "#sc",
              // 触发验证码弹窗或无痕验证的元素
              // button: "#sc",
              // 验证码验证通过回调函数
              success: function (captchaVerifyParam) {
                  _this.token = captchaVerifyParam
                  var formMess= {
                      phone: _this.showyzm1?_this.phone:_this.zhphone,
                      token: _this.token,
                      scene: 0,
                  }
                  axios.post("https://www.wenhua.com.cn/api/dataapi/GetMobileCode",qs.stringify(formMess),
                                {
                                  headers: {
                                    "Content-Type": "application/x-www-form-urlencoded",
                                  },
                                }
                              ).then((res)=>{
                                if(res.data.status){
                                  var time=60
                                  _this.canclick=false
                                  _this.ic.hide()
                                  _this.message="验证码已发送"
                                  _this.box=true
                                  document.documentElement.querySelector("#aliyunCaptcha-float-wrapper").remove()
                                  var timeset= setInterval(() => {
                                    if (time > 0) {
                                      if(_this.showyzm1){
                                          _this.txtyzm= "重新发送(" + time + "s)";
                                      }
                                      else{
                                        _this.txtyzm1 = "重新发送(" + time + "s)";
                                      }
                                      time--;
                                    } else {
                                      if(_this.showyzm1){
                                          _this.txtyzm= "重新发送";
                                          _this.canclick=true
                                      }
                                      else{
                                        _this.txtyzm1 = "重新发送";
                                        _this.canclick=true
                                      }
                                      clearInterval(timeset);
                                    }
                                  }, 1000);
                                                    
                                }
                                else{
                                  _this.message=res.data.msg
                                  _this.box=true
                                  _this.ic.hide()
                                  document.documentElement.querySelector("#aliyunCaptcha-float-wrapper").remove()
                                }

                              }).catch((err)=>{
                                  _this.ic.hide()
                                  document.documentElement.querySelector("#aliyunCaptcha-float-wrapper").remove()
                                  _this.message='发生异常，请联系管理员处理'
                                  _this.box=true
                                  console.log(err)
                              })
              },
              fail: function (result) {
                  // 入参为不通过信息
                  // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
                  console.error(result);
                  // alert(result.verifyCode)
              },
              // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
              getInstance: function (instance) {
                  _this.ic=instance
              },
              // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
              slideStyle: {
                  width: this.$refs.yzmcode.offsetWidth,
                  height: 40,
              },
              // width最小为320px，传入小于320数值将按320处理。
              // 若移动端部分机型上出现滑块宽度超过屏幕，可通过整体缩放功能解决
              rem: (this.$refs.yzmcode.offsetWidth>320) ? 1 : (this.$refs.yzmcode.offsetWidth / 320)
              // ...其他参数，参考initAliyunCaptcha参数说明
            });
          }
        })
    }
  },
  mounted() {
    this.setic()
  },
};
</script>
<style scoped>
.register_head {
  height: 275px;
  background: url(../assets/img/xz-banner.jpg) no-repeat center;
  /* border-bottom: 4px solid #f4b767; */
  position: relative;
}
.register_body {
  /* padding-bottom: 98px; */
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=76)no-repeat top,#f5f9fd;
  color: #656565;
  /* height: 734px; */
  /* overflow: hidden; */
  padding-top: 138px;
}
.register_white{
    width: 1060px;
    background: white;
    margin: 0 auto;
    height: 100%;
    padding-bottom: 120px;
    border-radius: 10px;
    box-shadow: 0 0 20px -5px #ccc;
}
.register_form{
  width: 580px;
    margin: 0 auto;
}
.register_tit{
  padding: 70px 0 35px 0;
  color: #542a08;
  text-align: center;
  font-size: 17px;
  font-weight: bold;
}
.register_mid{
  color: #848a94;
  text-align: left;
  font-size: 14px;
}
.register_body label{
  margin-right: 20px;
}
.register_body input[type="radio"]{
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
.register_body input[type="text"]{
  border: 1px solid #bebfbf;
  height: 32px;
  width: 342px;
  padding-left: 8px;
}
.regform-td{
  height: 32px;
  margin: 20px 0;
}
.regform-td span{
  display: inline-block;
  width: 150px;
  text-align: right;
  padding-right: 8px;
}
.regform-btn{
  color: white;
  background:#e8a451 ;
  width: 132px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  letter-spacing: 2px;
  border-radius: 8px;
  margin: 30px auto;
  cursor: pointer;
}
.getyzm{
  width: 110px;
  height: 32px;
  margin-left: 10px;
  line-height: 32px;
  cursor: pointer;
  background: #e3ebf8;
  color: #5292d2;
  border: 1px solid #d0d0d0;
  text-align: center;
  display: inline-block;
}
#sc{
  position: absolute;
  margin: 0;
  right: 0;
  top: -2px;
  background: white;
}
.regformlink span{
  display: inline-block;
  color: #4f79a9;
  border-bottom: 1px solid #4f79a9;
  cursor: pointer;
  margin: 0 10px;
}
.regformlink a{
  text-decoration: none;
}
.regformlink a:visited{
  color: #4f79a9;
}
.activetyzh{
    color: #ebb263 !important;
    border-bottom: 1px solid #ebb263 !important;
}
.huang{
    border-top: 6px solid #ebb263;
    border-left: 6px solid #fff;
    border-right: 6px solid #fff;
    position: absolute;
    bottom: -7px;
    left: 39%;
    border-bottom: none !important;
}
input:focus {
  outline: none;
}
:deep(#aliyunCaptcha-float-wrapper) {
  margin-bottom: 0 !important;
}
</style>